/** IconPark outline icons — https://iconpark.oceanengine.com/official */
import {
  ActivitySource,
  Ad,
  AddUser,
  Agreement,
  Application,
  ArrowRight,
  Audit,
  Bank,
  Briefcase,
  Broadcast,
  BuildingFour,
  BuildingTwo,
  Calendar,
  Caution,
  ChartHistogram,
  Check,
  CheckOne,
  Chinese,
  Click,
  Clipboard,
  Close,
  CloseRemind,
  CommentOne,
  Communication,
  CooperativeHandshake,
  Copy,
  Credit,
  Delete,
  Down,
  Download,
  Earth,
  Edit,
  Error,
  Excel,
  Eyes,
  FileCabinet,
  FileDoc,
  FileProtection,
  FileText,
  Filter,
  FinancingOne,
  FolderOpen,
  FullScreenOne,
  Gavel,
  GridNine,
  Handbag,
  HardDisk,
  Harm,
  Home,
  Inbox,
  Info,
  Iphone,
  Key,
  Left,
  Level,
  Lightning,
  Link,
  ListView,
  LoadingFour,
  Lock,
  Logout,
  Magic,
  Mail,
  Message,
  Minus,
  More,
  Movie,
  NewspaperFolding,
  Notes,
  OffScreen,
  Peoples,
  Phone,
  PhoneCall,
  PhoneOff,
  Pic,
  Pin,
  Platte,
  Plus,
  PreviewCloseOne,
  Protect,
  Puzzle,
  Refresh,
  Remind,
  Right,
  Rocket,
  Save,
  Scissors,
  Search,
  Send,
  Setting,
  ShareOne,
  ShareTwo,
  Slide,
  Star,
  Time,
  Timeline,
  Timer,
  Translate,
  TrendingDown,
  TrendingUp,
  Trophy,
  TwoDimensionalCode,
  Up,
  Upload,
  UploadOne,
  User,
  Video,
  VideoConference,
  Videocamera,
  Voice,
  VoiceOff,
} from '@icon-park/react'

export const ICON_PARK_COMPONENTS = {
  home: Home,
  dashboard: Application,
  deal: Handbag,
  postDeal: UploadOne,
  search: Search,
  progress: ChartHistogram,
  activity: ActivitySource,
  chat: Communication,
  email: Mail,
  mail: Mail,
  files: FolderOpen,
  fileText: FileText,
  digest: NewspaperFolding,
  upgrade: Level,
  settings: Setting,
  users: Peoples,
  members: Peoples,
  chart: ChartHistogram,
  barChart: ChartHistogram,
  dollar: FinancingOne,
  calendar: Calendar,
  meeting: VideoConference,
  fund: BuildingFour,
  portfolio: BuildingFour,
  bank: Bank,
  shield: Protect,
  bell: Remind,
  bellOff: CloseRemind,
  lock: Lock,
  collaborate: CooperativeHandshake,
  video: Video,
  videoOff: OffScreen,
  globe: Earth,
  clock: Time,
  alert: Caution,
  alertTriangle: Caution,
  policy: FileProtection,
  report: Notes,
  image: Pic,
  zap: Lightning,
  pin: Pin,
  copy: Copy,
  expand: FullScreenOne,
  megaphone: Broadcast,
  sparkles: Magic,
  clipboard: Clipboard,
  logout: Logout,
  contracts: Agreement,
  listings: ListView,
  payment: Credit,
  plus: Plus,
  trash: Delete,
  externalLink: ShareOne,
  moderation: Harm,
  admin: Audit,
  folder: FolderOpen,
  inbox: Inbox,
  campaign: Ad,
  translate: Translate,
  security: Lock,
  check: Check,
  chevronRight: Right,
  star: Star,
  trendUp: TrendingUp,
  info: Info,
  warning: Caution,
  timer: Timer,
  scissors: Scissors,
  puzzle: Puzzle,
  building: BuildingFour,
  newspaper: NewspaperFolding,
  download: Download,
  upload: Upload,
  close: Close,
  link: Link,
  creditCard: Credit,
  key: Key,
  pen: Edit,
  mobile: Iphone,
  palette: Platte,
  coinvest: CooperativeHandshake,
  templates: FileDoc,
  tracking: Timeline,
  dispute: Gavel,
  feedback: CommentOne,
  review: Audit,
  spreadsheet: Excel,
  archive: FileCabinet,
  phone: Phone,
  userPlus: AddUser,
  briefcase: Briefcase,
  messageSquare: Message,
  loader: LoadingFour,
  eye: Eyes,
  eyeOff: PreviewCloseOne,
  mic: Voice,
  micOff: VoiceOff,
  fileSignature: Agreement,
  qrCode: TwoDimensionalCode,
  checkCircle: CheckOne,
  save: Save,
  filter: Filter,
  rocket: Rocket,
  lp: Briefcase,
  startup: Rocket,
  share: ShareOne,
  share2: ShareTwo,
  chevronDown: Down,
  file: FileText,
  presentation: Slide,
  spreadsheetFile: Excel,
  usersGroup: Peoples,
  x: Close,
  phoneCall: PhoneCall,
  phoneOff: PhoneOff,
  building2: BuildingTwo,
  user: User,
  arrowRight: ArrowRight,
  barChart3: ChartHistogram,
  dollarSign: FinancingOne,
  send: Send,
  refresh: Refresh,
  refreshCw: Refresh,
  mousePointer: Click,
  xCircle: Error,
  fileSpreadsheet: Excel,
  videoFile: Movie,
  externalLinkAlt: ShareOne,
  mapPin: Pin,
  trendDown: TrendingDown,
  storage: HardDisk,
  chinese: Chinese,
  trophy: Trophy,
  chevronLeft: Left,
  chevronUp: Up,
  minus: Minus,
  more: More,
  videoCamera: Videocamera,
  gridView: GridNine,
  listView: ListView,
}
